<template>
  <div class="project-tree-selector d-flex flex-column flex-grow-1 section-container"
   :class="{'dark':skinType}">
    <el-input :suffix-icon="isShowTree?'el-icon-arrow-up':'el-icon-arrow-down'" slot="reference"
     v-model="filterText" placeholder="筛选条件" @focus="isShowTree=true"></el-input>
     <div class="none-height flex-grow-1" style="overflow-y: auto">
         <el-tree
          ref="tree"
          :highlight-current="true"
          v-show="isShowTree" :data="shortNodeList"
          :check-on-click-node="true"
          :filter-node-method="filterNode"
          :class="{'dark':skinType}"
          :expand-on-click-node="false"
          :props="defaultProps" @node-click="handleNodeClick">
        </el-tree>
     </div>
  </div>
  </template>
  <script>
  import clone from '@/utils/clone';
  
  export default {
    name: 'project-tree-selector',
    props: {
      levelType: {
        type: String,
        default: null,
      },
    },
    data() {
      return {
        selectProject: null,
        isShowTree: true,
        filterText: '',
        defaultProps: {
          children: 'Children',
          label: 'ModelName',
        },
        shortNodeList: [],
      };
    },
    created() {
      this.requestEquipmentTree();
    },
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      },
      selectProject(newVal) {
        this.$emit('select-node', newVal);
      },
      nodeList(newVal) {
        this.getInitialSelectProject();
        this.$emit('node-list', newVal);
      },
    },
    computed: {
      nodeList() {
        console.log('projectList', this.$store.getters.projectList);
        return this.$store.getters.projectList;
      },
      skinType() {
        return this.$store.getters.skinType;
      },
    },
    methods: {
      getInitialSelectProject() {
        if (this.nodeList === null) {
          return;
        }
        this.shortNodeList = this.getLevelList(clone(this.nodeList));
        [this.selectProject] = this.shortNodeList;
        this.$emit('select-node', this.selectProject);
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.ModelName.indexOf(value) !== -1;
      },
      getLevelList(res) {
        if (!this.levelType) {
          return res;
        }
        const arr = [];
        for (let i = 0; i < res.length; i += 1) {
          const nodeInfo = res[i];
          if (this.nodeHasLevelType(nodeInfo)) {
            arr.push(nodeInfo);
          }
        }
        return arr;
      },
      // 判断nodeList是否包含 projectLevelSelector
      nodeHasLevelType(nodeInfo) {
        let hasLevelType = false;
        if (this.getLevelTypes().indexOf(nodeInfo.oType) >= 0) {
          // eslint-disable-next-line no-param-reassign
          nodeInfo.Children = null;
          hasLevelType = true;
        }
        if (nodeInfo.Children) {
          for (let i = 0; i < nodeInfo.Children.length; i += 1) {
            const childInfo = nodeInfo.Children[i];
            if (this.nodeHasLevelType(childInfo)) {
              hasLevelType = true;
            }
          }
        }
        return hasLevelType;
      },
      getLevelTypes() {
        const types = [];
        switch (this.levelType) {
          case 'jcx':
            types.push('jx');
            types.push('cx');
            break;
          default:
            types.push(this.levelType);
            break;
        }
        return types;
      },
      handleNodeClick(data) {
        this.selectProject = data;
      },
      requestEquipmentTree() {
        if (this.nodeList === null) {
          this.$store.dispatch('projects/projectList');
          return;
        }
        this.getInitialSelectProject();
        this.$emit('node-list', this.nodeList);
        this.$emit('select-node', this.selectProject);
      },
    },
  };
  </script>
  <style scoped>
  .dark .el-tree{
    color:#ffffff;
  }
  </style>
  